import { carriesPrenatalScope, prenatalScopeFrom } from './prenatalScope';
import React, { useContext } from 'react';
import Grid from '@mui/material/Grid';
import ModalButtons from 'src/components/UI/button/ModalButtons';
import { APICONSTANTS, HPO_CONSTANTS } from 'src/components/Constants';
import moment from 'moment';

import axios from 'src/axios';

import {
  Box,
  FormControl,
  TextField,
  Switch,
  Typography,
  IconButton,
  Button,
  Tooltip,
  InputAdornment,
  MenuItem
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {
  getDependencies,
  VARIANT_INTERPRETATION_OPTIONS,
  VARIANT_ORIGIN_OPTIONS,
  getConsentTags,
  getClinicalDefaults,
  saveClinicalDefault,
  deleteClinicalDefault
} from './formService';

import { calculateAgeOnDate, getHPOSearchURL } from 'src/util/util';
import { toLocalDateFromPickerOrImport } from 'src/util/partialDate';
import {
  readTerminologyAvailability,
  terminologyAvailabilityFromError
} from 'src/util/terminologyAvailability';
import Alert from '@mui/material/Alert';
import {
  SnackContext,
  AppContext,
  ThemeContext,
  UserContext
} from 'src/store/ContextStore';
import AutocompleteInput from 'src/components/UI/input/AutocompleteInput';
import TextInput from 'src/components/UI/input/TextInput';

import UploadFileList from 'src/components/UI/input/UploadFileList';
import { useAttachmentChanges } from 'src/components/UI/input/attachments';
import SelectInput from 'src/components/UI/input/SelectInput';
import ClinicalNoteDeleteModal from '../../diagnoses-menu/ClinicalNoteDeleteModal';
import FormLabel from 'src/components/UI/input/CustomFormLabel';
import DateInput from 'src/components/UI/input/DateInput';
import AssociatedNote from 'src/components/UI/input/AssociatedNote';
import SavedVariantTile from './SavedVariantTile';
import { useClinicalSuggestions } from 'src/hooks/useClinicalSuggestions';
import { acceptedMessage } from 'src/components/UI/clinicalSuggestions/acceptOutcome';
import ClinicalSuggestionsPanel from 'src/components/UI/ClinicalSuggestionsPanel';
import { pushVariantsOntoMemberRow } from '../../genotypes-menu/memberGenotypesRow';
import { useMemberRowSync } from 'src/components/pedigree-chart/pedigree-tool/memberRowSyncContext';
import { mintObjectIdHex } from 'src/components/pedigree-chart/pedigree-tool/pedigree/saveReconciliation';
import { useStructuredTestResultsEnabled } from 'src/hooks/useStructuredTestResults';
import { useLabReportReview } from 'src/hooks/useLabReportReview';
import LabReportApply from '../../test-results/LabReportApply';
import LabReportsList from '../../test-results/LabReportsList';
import {
  FIELD_LABELS,
  applyPlan,
  changedAfterTheReport,
  conflictsOf,
  dayOf,
  planApplication,
  unsavedRowsFromReport,
  unapplyReport,
  unsavedTestChanges,
  variantLabel,
  withChoice,
  withdrawalOntoForm
} from '../../test-results/applyProposal';
import {
  getPath,
  requiresIdentityAcknowledgement,
  setPath
} from '../../test-results/labReportDisplay';
import {
  describeTestResultError,
  notifyTestResultsChanged
} from 'src/hooks/useStructuredTestResults';
import FromReportMark from './test-record/FromReportMark';
import UnsavedChangeNote from 'src/components/UI/input/UnsavedChangeNote';
import {
  unsavedControlSx,
  unsavedFieldSx
} from 'src/components/UI/input/unsavedChange';
import { keptVariantsMessage } from '../../test-results/labReportDisplay';
import { sentToInboxLines } from '../../test-results/labReportInboxText';
import { SgAccessContext } from 'src/components/manage-users/SgAcessProvider';
import SectionHeading from './test-record/SectionHeading';
import GenesTestedTable from './test-record/GenesTestedTable';
import GeneListStateField from './test-record/GeneListStateField';
import VariantsByGene from './test-record/VariantsByGene';
import TestScopeField from './test-record/TestScopeField';
import {
  GENOME_BUILDS,
  TRANSCRIPT_HELP,
  addGeneRows,
  geneIdsOf,
  geneKeyOf,
  isGeneSymbolKey,
  isReportVariant,
  isVersionedTranscript,
  newGeneRow,
  rowKeyOf,
  unlistedGeneStateOf
} from './test-record/testRecordModel';
import {
  VerificationContext,
  highlightSx,
  useVerificationView
} from 'src/components/lab-report-verification/useVerificationView';
import VerificationLayout from 'src/components/lab-report-verification/VerificationLayout';
import ReportPane from 'src/components/lab-report-verification/ReportPane';
import AnchorMark from 'src/components/lab-report-verification/AnchorMark';
import SavedReportChecks from 'src/components/lab-report-verification/SavedReportChecks';
import { fieldTarget } from 'src/components/lab-report-verification/verificationTargets';
import {
  inboxDocument,
  openReportInNewTab,
  savedDocument,
  uploadDocument,
  useSavedReportAnchors
} from 'src/components/lab-report-verification/reportSources';
import useReadingChecks, {
  ReadingChecksContext
} from 'src/components/lab-report-verification/useReadingChecks';
import { proposedListState } from 'src/components/lab-report-verification/verificationGroups';
import {
  needsWithheldMatching,
  withheldMatchesOf
} from 'src/components/lab-report-verification/withheldMatches';
import GeneListCard from 'src/components/lab-report-verification/GeneListCard';
import VariantGroupCards, {
  FindingsNotOnTest
} from 'src/components/lab-report-verification/VariantGroupCards';
import OverallResultCard, {
  OVERALL_RESULT_PATH
} from 'src/components/lab-report-verification/OverallResultCard';
import VerificationFooter from 'src/components/lab-report-verification/VerificationFooter';
import {
  OTHERS_MARKED_SAVED_TEXT,
  choiceAnchors,
  choiceWaitText,
  forWhomOf,
  testIsForText
} from 'src/components/lab-report-verification/whichIndividual';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const isPdfFile = (file, name) =>
  file?.type === 'application/pdf' ||
  /\.pdf$/i.test(String(file?.name || name || ''));

const NO_MARKS = Object.freeze({
  fields: new Set(),
  genes: new Set(),
  findings: new Set()
});
const NO_CHANGES = Object.freeze({
  fields: new Set(),
  genes: new Set(),
  variants: new Set()
});
const without = (set, value) => {
  if (!set.has(value)) return set;
  const next = new Set(set);
  next.delete(value);
  return next;
};

// The Test's genes tested with `gene` listed, when it is a gene symbol and not listed already
// (TGCLOUD-1866, Phase 2 rework): a variant added in a gene says that gene was tested. `ids` are
// the gene lookup's, when the gene was chosen from it.
const withGeneListed = (genesTested, gene, ids = {}) => {
  const key = geneKeyOf(gene);
  if (!isGeneSymbolKey(key)) return genesTested;
  const { next, added } = addGeneRows(genesTested, [
    newGeneRow({
      symbol: key,
      symbolAsPrinted: String(gene).split(' — ')[0].trim(),
      ...ids
    })
  ]);
  return added.length ? next : genesTested;
};

// Is the variant editor's entry identical to a variant the Test already holds? Compared on what
// the editor holds: a gene by its key (the lookup's label and its symbol are one gene), text
// trimmed, a blank as a blank, an origin nobody gave as the editor's 'unknown', a date by its day.
// Save adds the editor's entry as a new variant, and must not add one the Test already has.
const EDITOR_TEXT_FIELDS = Object.freeze([
  'variantG',
  'variantC',
  'variantP',
  'variantInterpretation',
  'transcript',
  'genomeBuild'
]);
const editorText = (value) =>
  typeof value === 'string' ? value.trim() : value == null ? '' : value;
const sameEditorEntry = (a, b) =>
  geneKeyOf(a?.gene) === geneKeyOf(b?.gene) &&
  EDITOR_TEXT_FIELDS.every(
    (field) => editorText(a?.[field]) === editorText(b?.[field])
  ) &&
  (editorText(a?.origin) || 'unknown') ===
    (editorText(b?.origin) || 'unknown') &&
  dayOf(a?.dateLastReviewed) === dayOf(b?.dateLastReviewed);

export default function TestForm({
  data,
  handleClose,
  familyMemberId,
  isProband,
  isEditing,
  model,
  staffMembers,
  staffMemberOptions,
  setUnsavedChanges,
  refreshPedigreeLabels,
  // A lab report is one person's, so a Test that is replayed for several people (the bulk
  // editor) does not read one (TGCLOUD-1866).
  labReportReview = true,
  // A lab report inbox item matched to this person, handed to this Test (TGCLOUD-1866 Phase 3:
  // the deep link from the inbox, ClinicalNotes.jsx). Read once, on mount; see THE HAND-OFF below.
  labReportInboxItemId = null,
  // For a report about several people, whose part of it the item is handed over for (TGCLOUD-1868,
  // Phase E4: the link's `individual`, { key, role, pregnancyId?, fetusId? }), or null.
  labReportInboxIndividual = null,
  // (mode) => void: 'review' while a lab report is checked beside this Test, 'saved' while a saved
  // Test's report is open, null otherwise (TGCLOUD-1868 D2). The dialog fills the window for the
  // first two; see THE VERIFICATION VIEW below.
  onVerificationModeChange
}) {
  const t = useAutoTranslation();

  const { content } = React.useContext(AppContext);
  // A member of a read-only security group sees the Test and changes nothing: the server refuses
  // their every clinical write (securityGroupReadOnlyGuard), so nothing that writes is offered. The
  // same rule the pedigree's other screens read (SgAcessProvider readOnly('pedigrees')).
  const { readOnly: securityGroupReadOnly, allow: securityGroupAllow } =
    React.useContext(SgAccessContext);
  const readOnly = securityGroupReadOnly('pedigrees');
  // "Send to the inbox instead" makes an inbox item, so it is offered only to someone the inbox
  // admits (an opt-in security-group module, SgAcessProvider OPT_IN_MODULES) who may write there.
  const mayUseInbox =
    !!securityGroupAllow?.('labReportInbox') &&
    !securityGroupReadOnly('labReportInbox');
  // The hand-off's item, unless this is the bulk editor (a report is one person's).
  const inboxHandOff =
    labReportReview !== false && labReportInboxItemId
      ? String(labReportInboxItemId)
      : null;
  const { pedigreeSelectedUsers: users } = content;
  const { selectedUser: user } = users;
  const { theme } = useContext(ThemeContext);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { user: loggedInUser } = React.useContext(UserContext);
  const [geneSearchTerm, setGeneSearchTerm] = React.useState('');
  const [geneOptions, setGeneOptions] = React.useState([]);
  const [geneUnavailable, setGeneUnavailable] = React.useState(null);
  const [testNameOptions, setTestNameOptions] = React.useState([]);
  const [testTypeOptions, setTestTypeOptions] = React.useState([]);
  const [labOptions, setLabOptions] = React.useState([]);
  const [testResultOptions, setTestResultOptions] = React.useState([]);

  const patientDob = data?.dob;
  // The age on the calendar day the Test was requested (calculateAgeOnDate).
  // The date requested is handed over as stored: a re-opened Test's may be an
  // imported UTC-midnight date rather than a picker instant, and only the raw
  // value says which (toLocalDateFromPickerOrImport). `calculateAge` counted
  // elapsed time from a UTC-midnight birth date, so on the birthday itself it
  // was a year short at any positive offset — and re-opening such a Test
  // rewrote its stored age to the wrong one.
  const computeAgeWhenTested = React.useCallback(
    (dateRequested) => calculateAgeOnDate(patientDob, dateRequested),
    [patientDob]
  );
  // Every date field below reads through the same writer-aware reader, so the
  // day shown is the day the age was worked out from. DateInput's own reader
  // (toLocalDate) reads a picker instant by its UTC day, which in Sydney showed
  // a Test requested at 9am on 12 March as 11 March.
  const asPickerDay = toLocalDateFromPickerOrImport;

  // A NEW Test opened from the lab report inbox starts with no date requested: the report's own
  // date fills the date received, and a default "today" would only be a date to clear (plan, Phase
  // 3 hand-off step 2). Every other new Test keeps today's default.
  const defaultDateRequested = inboxHandOff ? null : new Date();
  const defaultValues = isEditing
    ? {
        ...model,
        requestedBy: Array.isArray(model.requestedBy)
          ? model.requestedBy.map((r) => r.userId || r._id).filter(Boolean)
          : []
      }
    : {
        familyId: user.familyId,
        familyMemberId: familyMemberId,
        // PRENATAL SCOPE (decision 21) — see prenatalScope.js for why every prenatal-capable form
        // must spread this. Empty for an ordinary test.
        ...prenatalScopeFrom(model),
        testName: '',
        testType: '',
        lab: '',
        dateRequested: defaultDateRequested,
        dateResultDue: null,
        dateResultReceived: null,
        ageWhenTested: computeAgeWhenTested(defaultDateRequested),
        testResult: '',
        testNotes: '',
        fileAttachments: [],
        showInFamily: false,
        variants: [],
        associatedConsent: { label: 'none', _id: '' },
        requestedBy: loggedInUser._id ? [loggedInUser._id] : [],
        reminderEnabled: false,
        reminderDate: null
      };

  const [formValues, setFormValues] = React.useState(defaultValues);
  // The form as last drawn, for a step that finishes after an await (applying a reading) or that
  // must say what it found before it changes the form (taking a report off).
  const formValuesRef = React.useRef(formValues);
  formValuesRef.current = formValues;
  // What was entered for the lab report applied to the form, beyond what it put there itself: the
  // gene rows added and whether the list state was chosen while it was applied (TGCLOUD-1868,
  // review of the view). Taking the report off takes these off too (applyProposal.unapplyReport).
  const enteredForReport = React.useRef({
    key: null,
    genes: new Set(),
    listState: false
  });
  const enteredFor = (key) => {
    if (enteredForReport.current.key !== key) {
      enteredForReport.current = { key, genes: new Set(), listState: false };
    }
    return enteredForReport.current;
  };
  // The review applied to the form now (set where it is known, below), for the handlers above it.
  const appliedKeyRef = React.useRef(null);
  // THE DEFAULT REQUEST DATE (Tim, 2026-09-30). A new Test's date requested defaults to the day the
  // form opened, which is not a request date. While it is still that untouched default, a lab
  // report's application says so (`requestDateIsDefault`), and the save clears it when the report
  // is dated earlier (backend applyLabReport.applyRequestDateRule). Picking a date, or saving,
  // makes it the clinician's.
  const [requestDateIsDefault, setRequestDateIsDefault] = React.useState(
    !isEditing && !inboxHandOff
  );
  // What a lab report put into the form and nobody has changed since: marked "from the report"
  // until the Test is saved. Fields by name, genes by key, variants by findingId.
  const [fromReport, setFromReport] = React.useState(NO_MARKS);
  // UNSAVED CHANGES (Tim's decisions, 2026-10-01). While a lab report is applied to this form and
  // the Test is not saved yet, everything that differs from the Test as last saved is drawn as the
  // data entry grid draws an unsaved change (gold): what the report filled, and every edit, the
  // report's field or not (applyProposal.unsavedTestChanges). The "from the report" chip says only
  // that a value is still exactly the report's. With no report applied nothing is gold, as before.
  // Saving clears it (the applied report is recorded); a refused save keeps it; closing discards
  // it with the form. The Test as last saved: as loaded, until a save or a withdrawal changes it.
  const [lastSaved, setLastSaved] = React.useState(defaultValues);
  // The verification view, once it is made below: a value still the report's that the clinician
  // changes is counted as a value edited (TGCLOUD-1868 D7), here where its "from the report" goes.
  const verificationRef = React.useRef(null);
  // The reading's checks, once they are made below (THE GROUPS): the variant editor reports a
  // low-confidence value entered there.
  const checksRef = React.useRef(null);
  // The review being checked in the view, for a step that finishes after an await.
  const activeReviewRef = React.useRef(null);
  const unmark = (kind, value) => {
    if (fromReport[kind].has(value)) verificationRef.current?.valueEdited();
    setFromReport((prev) =>
      prev[kind].has(value)
        ? { ...prev, [kind]: without(prev[kind], value) }
        : prev
    );
  };
  const [saveError, setSaveError] = React.useState(null);
  // Attachment deletes wait for a successful save (TGCLOUD-1850).
  const attachmentChanges = useAttachmentChanges(defaultValues.fileAttachments);
  const [uploadingFiles, setUploadingFiles] = React.useState(false);

  const allStaffMembers = React.useMemo(() => {
    return staffMemberOptions.map((options) => options.value);
  }, [staffMemberOptions]);

  const staffMembersMap = React.useMemo(() => {
    return staffMemberOptions.reduce((acc, item) => {
      acc[item.value] = item.label;
      return acc;
    }, {});
  }, [staffMemberOptions]);

  const emptyVariant = {
    gene: '',
    variantG: '',
    variantC: '',
    variantP: '',
    variantInterpretation: '',
    origin: 'unknown',
    dateLastReviewed: null
  };
  const [currentVariant, setCurrentVariant] = React.useState(emptyVariant);
  const [editingVariantIndex, setEditingVariantIndex] = React.useState(null);
  const variantEditorRef = React.useRef(null);
  // The gene lookup's ids for the gene chosen in the variant editor, for the genes tested row a
  // new variant lists; cleared whenever the gene is typed rather than chosen.
  const variantGeneIdsRef = React.useRef({});
  // The option last chosen from the gene lookup. The gene search shows it as its selection only
  // while the editor's gene is still that option's name (see the Autocomplete below).
  const [geneChoice, setGeneChoice] = React.useState(null);
  const isEditingVariant = editingVariantIndex !== null;
  const markUnsaved = () =>
    setUnsavedChanges((prev) => ({ ...prev, edit: true }));

  const scrollToVariantEditor = () =>
    requestAnimationFrame(() => {
      variantEditorRef.current?.scrollIntoView?.({
        behavior: 'smooth',
        block: 'start'
      });
    });

  const handleAddVariant = () => {
    if (!currentVariant.gene) return;
    const ids = variantGeneIdsRef.current;
    setFormValues((prev) => {
      const next = {
        ...prev,
        variants: [...(prev.variants || []), { ...currentVariant }]
      };
      const listed = withGeneListed(prev.genesTested, currentVariant.gene, ids);
      if (listed !== prev.genesTested) next.genesTested = listed;
      return next;
    });
    setCurrentVariant(emptyVariant);
    variantGeneIdsRef.current = {};
    markUnsaved();
  };

  const handleUpdateVariant = () => {
    if (editingVariantIndex === null) return;
    if (!currentVariant.gene) return;
    if (currentVariant.findingId) unmark('findings', currentVariant.findingId);
    // A value the reader was not confident of, entered here rather than on the variant's card:
    // compared with the reading and counted the same way (TGCLOUD-1868 D3, D7).
    const before = formValues.variants?.[editingVariantIndex];
    const checksNow = checksRef.current;
    if (checksNow?.active && currentVariant.findingId) {
      for (const group of [
        checksNow.identityGroupOf(currentVariant.findingId),
        checksNow.classificationGroupOf(currentVariant.findingId)
      ]) {
        for (const low of group ? checksNow.lowOf(group.key) : []) {
          const field = low.place?.field;
          if (!field || low.place.findingId !== currentVariant.findingId) {
            continue;
          }
          const now = getPath(currentVariant, field);
          if (JSON.stringify(getPath(before, field)) !== JSON.stringify(now)) {
            checksNow.commit(low.path, now);
          }
        }
      }
    }
    setFormValues((prev) => ({
      ...prev,
      variants: (prev.variants || []).map((v, i) =>
        i === editingVariantIndex ? { ...currentVariant } : v
      )
    }));
    setCurrentVariant(emptyVariant);
    setEditingVariantIndex(null);
    setUnsavedChanges((prev) => ({ ...prev, edit: true }));
  };

  const handleEditVariant = (index) => {
    const target = formValues.variants?.[index];
    if (!target) return;
    setCurrentVariant({ ...emptyVariant, ...target });
    setEditingVariantIndex(index);
    scrollToVariantEditor();
  };

  // "Add a variant in MLH1": the editor, ready for that gene.
  const handleAddVariantInGene = (gene) => {
    setCurrentVariant({ ...emptyVariant, gene });
    setEditingVariantIndex(null);
    variantGeneIdsRef.current = {};
    scrollToVariantEditor();
  };

  // ── Genes tested (TGCLOUD-1866, Phase 2 rework) ──
  // Keyed by gene, never by position: the table is searched, filtered and paged.
  const handleAddGenes = (rows) => {
    // Entered while a lab report is applied: the genes the report lists, typed from it.
    if (appliedKeyRef.current) {
      const entered = enteredFor(appliedKeyRef.current);
      for (const row of rows || []) entered.genes.add(rowKeyOf(row));
    }
    setFormValues((prev) => ({
      ...prev,
      genesTested: addGeneRows(prev.genesTested, rows).next
    }));
    markUnsaved();
  };
  const handleChangeGene = (key, row) => {
    unmark('genes', key);
    setFormValues((prev) => ({
      ...prev,
      genesTested: (prev.genesTested || []).map((r) =>
        rowKeyOf(r) === key ? row : r
      )
    }));
    markUnsaved();
  };
  const handleRemoveGene = (key) => {
    unmark('genes', key);
    setFormValues((prev) => ({
      ...prev,
      genesTested: (prev.genesTested || []).filter((r) => rowKeyOf(r) !== key)
    }));
    markUnsaved();
  };
  const handleListGene = (gene) => {
    setFormValues((prev) => {
      const listed = withGeneListed(prev.genesTested, gene);
      return listed === prev.genesTested
        ? prev
        : { ...prev, genesTested: listed };
    });
    markUnsaved();
  };

  const handleCancelEditVariant = () => {
    setCurrentVariant(emptyVariant);
    setEditingVariantIndex(null);
  };

  const handleDeleteVariant = (index) => {
    const findingId = formValues.variants?.[index]?.findingId;
    if (findingId) unmark('findings', findingId);
    setFormValues((prev) => ({
      ...prev,
      variants: prev.variants.filter((_, i) => i !== index)
    }));
    if (editingVariantIndex === index) {
      setCurrentVariant(emptyVariant);
      setEditingVariantIndex(null);
    } else if (editingVariantIndex !== null && index < editingVariantIndex) {
      setEditingVariantIndex(editingVariantIndex - 1);
    }
    setUnsavedChanges((prev) => ({ ...prev, edit: true }));
  };

  React.useEffect(() => {
    if (geneSearchTerm.length < 3) {
      setGeneOptions([]);
      return;
    }
    const url = getHPOSearchURL(
      geneSearchTerm,
      HPO_CONSTANTS.initialPage,
      HPO_CONSTANTS.category['gene']
    );
    axios
      .get(url)
      .then(({ data }) => {
        // The catch below used to swallow every failure into an empty list
        // without even binding the error, so an outage, an admin-disabled
        // HGNC and an empty vocabulary were one indistinguishable empty
        // dropdown on the variant row (TGCLOUD-1785).
        setGeneUnavailable(readTerminologyAvailability(data));
        const { results = [] } = data || {};
        setGeneOptions(results.map((d) => ({ id: d.id, name: d.name })));
      })
      .catch((err) => {
        setGeneUnavailable(terminologyAvailabilityFromError());
        setGeneOptions([]);
        console.error('Error fetching genes:', err);
      });
  }, [geneSearchTerm]);

  React.useEffect(() => {
    getClinicalDefaults('testNames').then(setTestNameOptions);
    getClinicalDefaults('testTypes').then(setTestTypeOptions);
    getClinicalDefaults('laboratories').then(setLabOptions);
    getClinicalDefaults('testResults').then(setTestResultOptions);
  }, []);

  const [reminderTouched, setReminderTouched] = React.useState(false);
  const computeDefaultReminderDate = React.useCallback((reqDate) => {
    if (!reqDate) return null;
    return moment(reqDate).add(14, 'days').toDate();
  }, []);

  let [consentOptions, setConsentOptions] = React.useState(['loading...']);
  React.useEffect(() => {
    const fetchData = async () => {
      const consentTags = await getConsentTags(
        theme,
        familyMemberId,
        formValues.familyId
      );
      setConsentOptions(consentTags);
    };
    if (consentOptions != [] && consentOptions[0] == 'loading...') fetchData();
  }, []);

  const [error, setError] = React.useState({});

  const clearEitherDateErrors = () => {
    setError((prev) => {
      const next = { ...prev };
      if (typeof next.dateRequested === 'string') delete next.dateRequested;
      if (typeof next.dateResultReceived === 'string')
        delete next.dateResultReceived;
      return next;
    });
  };

  const handleChange = (e) => {
    unmark('fields', e.target.name);
    if (e.target.name === 'dateRequested') {
      setRequestDateIsDefault(false);
      const nextReq = e.target.value;
      if (nextReq) clearEitherDateErrors();
      if (!formValues.reminderEnabled || !reminderTouched) {
        const nextDefault = computeDefaultReminderDate(nextReq);
        setFormValues((prev) => ({ ...prev, reminderDate: nextDefault }));
      }
      setFormValues((prevValues) => ({
        ...prevValues,
        ageWhenTested: computeAgeWhenTested(nextReq)
      }));
    }

    if (e.target.type === 'date') {
      const selectedDate = new Date(e.target.value);
      const today = new Date();

      if (selectedDate >= today) {
        setError((prev) => ({ ...prev, [e.target.name]: true }));
      } else {
        setError((prev) => {
          const { [e.target.name]: _, ...rest } = prev;
          return rest;
        });
      }
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.value
    }));
    setUnsavedChanges((prev) => ({ ...prev, edit: true }));
  };

  const onToggleSwitch = (e) => {
    setUnsavedChanges((prev) => ({ ...prev, edit: true }));
    setFormValues((prevValues) => ({
      ...prevValues,
      [e.target.name]: e.target.checked
    }));
    if (familyMemberId == 'none') {
      setFormValues((prevValues) => ({
        ...prevValues,
        showInFamily: true
      }));
    }
  };

  const { setSnack } = React.useContext(SnackContext);
  // The chart's member rows, so the pushed variants can be put on this
  // person's row (memberGenotypesRow.js). Null outside a chart.
  const rowSync = useMemberRowSync();

  // A saved Test is the source of the variants accepted from its report
  // (TGCLOUD-1866 D8); a new one has no id yet, so its accepted variants
  // carry the text's own label. Its prenatal scope goes with every accept, a
  // new Test's included: from a Test about a pregnancy no genotype is written
  // onto this person (TGCLOUD-1868, decision 17).
  const clinicalSuggestions = useClinicalSuggestions({
    familyMemberId,
    isProband,
    sourceTestId: isEditing ? model?._id || null : null,
    sourceScope: {
      pregnancyId: formValues.pregnancyId,
      fetusId: formValues.fetusId
    }
  });
  const {
    analyzingNote,
    handleAttachmentText,
    forgetAttachment,
    analyzeText,
    acceptSuggestions
  } = clinicalSuggestions;

  // STRUCTURED TEST RESULTS (TGCLOUD-1866, Phase 2 rework: "the Test record is the home of the
  // result"). With the group's flag on, a PDF uploaded here is ALSO read as this Test's lab report
  // (POST /test-results/intake): the attachment upload and Suggested Clinical Terms are untouched.
  // The reading is applied to THIS FORM, and SAVING the Test records it, with
  // `labReportApplication` on the save. With the flag off none of it runs; the Test record's own
  // fields (genes tested, test scope) do not depend on it.
  //
  // The report is read for this Test, so the Test needs its id before it is saved. A new Test's id
  // is minted here the way a new person's is (mintObjectIdHex): PUT /clinical-notes/test upserts
  // by the `_id` it is sent, so the minted id becomes the saved Test's, and the save that applies
  // the report must name the Test the report was read for. Minted only when a report is uploaded,
  // so a Test saved without one is sent exactly as before.
  const labReportsOn =
    useStructuredTestResultsEnabled() &&
    labReportReview !== false &&
    !!familyMemberId &&
    familyMemberId !== 'none';
  // A read-only member reads no report: applying is a write, and the server refuses intake to them.
  const readsLabReports = labReportsOn && !readOnly;
  const labReport = useLabReportReview({ familyMemberId });
  const appliedReview = labReport.appliedReview;
  appliedKeyRef.current = appliedReview ? appliedReview.key : null;
  const testIdRef = React.useRef(defaultValues._id || null);
  // The id of this Test on the server, for its lab reports: an edited Test's.
  const savedTestId = isEditing && model?._id ? model._id : null;
  const ensureTestId = () => {
    if (!testIdRef.current) {
      const minted = mintObjectIdHex();
      testIdRef.current = minted;
      setFormValues((prev) => (prev._id ? prev : { ...prev, _id: minted }));
    }
    return testIdRef.current;
  };

  // THE HAND-OFF (TGCLOUD-1866 Phase 3). A report matched to this person in the lab report inbox is
  // read for THIS Test, once, when the form opens: POST /test-results/inbox/:id/intake, from the
  // server's stored copy. Its answer is intake's, so it is applied as an upload's is, when the view
  // opens, each group confirmed in place (TGCLOUD-1868 D3: no "Apply to this Test" any more), and the
  // save links the inbox item. A new Test gets its id here, as for an upload.
  // The ref keeps a re-render (or StrictMode's second effect) from reading it twice.
  //
  // One person of a report about several (TGCLOUD-1868, Phase E4) is read for this Test by their key,
  // and a fetus's by its fetus record too, the scope this Test was opened with (ClinicalNotes).
  const handedOff = React.useRef(null);
  // The item the hand-off has been asked for: until then, and while it is read, the verification
  // view shows the inbox's copy of the report (THE VERIFICATION VIEW below).
  const [handOffAsked, setHandOffAsked] = React.useState(null);
  React.useEffect(() => {
    if (!inboxHandOff || !readsLabReports) return;
    if (handedOff.current === inboxHandOff) return;
    handedOff.current = inboxHandOff;
    setHandOffAsked(inboxHandOff);
    labReport.readQueued(inboxHandOff, {
      testNoteId: ensureTestId(),
      individual: labReportInboxIndividual?.key
        ? labReportInboxIndividual
        : null
    });
    // ensureTestId and labReport.readQueued are stable for this purpose, and the individual comes
    // with the item, once: the ref is the guard.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inboxHandOff, readsLabReports]);
  // Why a Test opened from the inbox cannot read its report here, if it cannot.
  const inboxUnavailable =
    inboxHandOff && !readsLabReports
      ? readOnly
        ? t('your access to pedigrees is read-only')
        : !familyMemberId || familyMemberId === 'none'
        ? t('no saved person is selected')
        : t('structured test results are off for this group')
      : null;

  // A report dismissed, or sent to the inbox, comes off the form again: what it added goes, what
  // was entered for it goes (a Test result chosen from it, genes typed from it, the list state said
  // of them), and what it filled or was chosen for comes back as the Test held it, where nobody has
  // changed it since (applyProposal.unapplyReport). Answers with the fields it filled that were
  // changed since, which stay as changed: whoever took it off is told to check them.
  const takeOffReport = (review) => {
    const application = review?.application;
    if (review?.status !== 'applied' || !application) return [];
    const was = enteredForReport.current;
    const entered =
      was.key === review.key
        ? { genes: [...was.genes], listState: was.listState }
        : null;
    const choices = review.choices || {};
    const changed = changedAfterTheReport(formValuesRef.current, {
      plan: application.plan,
      choices
    });
    setFormValues((prev) =>
      unapplyReport(prev, {
        plan: application.plan,
        choices,
        labReportId: review.reading?.labReportId,
        before: application.before || {},
        listState: application.listState || null,
        entered
      })
    );
    setFromReport(NO_MARKS);
    if (was.key === review.key) enteredFor(null);
    return changed;
  };

  // "Send to the inbox instead": a report uploaded here that is someone else's goes to the lab
  // report inbox, to be matched to the right patient. Nothing of it stays on this Test: the review
  // goes, the PDF comes off the attachments (removed from storage when the Test is saved), and the
  // clinical terms suggested from it are no longer offered.
  const [sentToInbox, setSentToInbox] = React.useState([]);
  // What follows a report sent to the inbox: its PDF off the attachments, and where it went said.
  const sentFromThisTest = (review, answer, changed = []) => {
    const name = review.attachmentName;
    if (name) {
      setFormValues((prev) => ({
        ...prev,
        fileAttachments: (prev.fileAttachments || []).filter((n) => n !== name)
      }));
      forgetAttachment?.(name);
      markUnsaved();
    }
    // Said in words when it is drawn (labReportPanels), in the reader's language.
    setSentToInbox((prev) => [
      ...prev,
      { key: review.key, answer, attachmentRemoved: !!name, changed }
    ]);
  };
  const sendReviewToInbox = async (review) => {
    // The review being checked ends its telemetry session as sent to the inbox, before it goes.
    const result = await labReport.sendToInbox(review.key, {
      onSent: (sent) => {
        if (activeReviewRef.current?.key === sent.key) {
          verificationRef.current?.finish('sent-to-inbox');
        }
      }
    });
    if (!result?.ok) return;
    // It was applied on open: everything it put on the form comes off again.
    const changed = takeOffReport(result.review || review);
    sentFromThisTest(review, result.data, changed);
  };
  // ...while whose part of a report about several people this Test is is still chosen (TGCLOUD-1868,
  // Phase E routine call): the file itself, read for nobody, so nothing of the report was on the
  // form to come off it.
  const sendChoiceReviewToInbox = async (review) => {
    const result = await labReport.sendChoiceToInbox(review.key);
    if (!result?.ok) return;
    sentFromThisTest(review, result.data);
  };

  // THE VERIFICATION VIEW (TGCLOUD-1868, plan D2, D3, D5, D6, D7). While a lab report is checked
  // beside this Test, the form is the right of two panes and the report the left
  // (VerificationLayout), and the dialog around it fills the window (onVerificationModeChange):
  //   review  a review here has a reading: the applied review if there is one, else the first
  //           with a reading. An inbox hand-off shows the inbox's stored copy from the moment the
  //           form opens, while it is read; one that is refused leaves the view
  //   saved   "Open report" on one of this Test's lab reports: that report, read-only, with where
  //           each value the record keeps as the report's is printed, and how it was checked
  // It is the same form throughout: a Test that switches into the view keeps everything in it.
  // The bulk editor reads no report (labReportReview={false}), so it never gets the view.
  //
  // A report about two or more people (TGCLOUD-1868, Phase E4) is beside the Test from the moment it
  // asks whose the Test is (a `choosing` review), each person's row marked in it, and stays there
  // while it is read again for the person chosen.
  const verificationAllowed = labReportReview !== false;
  const [savedReport, setSavedReport] = React.useState(null);
  const activeReview = verificationAllowed
    ? appliedReview ||
      labReport.reviews.find((r) => r.status === 'ready' && !!r.reading) ||
      labReport.reviews.find(
        (r) => r.status === 'choosing' || (r.status === 'reading' && !!r.choice)
      ) ||
      null
    : null;
  activeReviewRef.current = activeReview;
  // SAVE WAITS WHILE THE CHOICE IS OPEN (TGCLOUD-1868, Phase E routine call): a Test saved while
  // whose part of the report it is is still being chosen would be saved without the report, which
  // could then only be uploaded again. The footer says why (whichIndividual.choiceWaitText).
  const choiceWaits = [
    ...new Set(labReport.reviews.map(choiceWaitText).filter(Boolean))
  ];
  // While whose the Test is is chosen, the report pane marks each person's row (whichIndividual.js).
  const choiceIndividuals =
    activeReview && !activeReview.reading
      ? activeReview.choice?.individuals || null
      : null;
  const choiceReading = React.useMemo(
    () =>
      choiceIndividuals ? { anchors: choiceAnchors(choiceIndividuals) } : null,
    [choiceIndividuals]
  );
  // The Test's prenatal scope: which person of a report about several it can take.
  const testScope = {
    pregnancyId: formValues.pregnancyId,
    fetusId: formValues.fetusId
  };
  const handOffPending =
    verificationAllowed &&
    !!inboxHandOff &&
    readsLabReports &&
    (handOffAsked !== inboxHandOff ||
      labReport.reviews.some(
        (r) => r.origin === 'inbox' && r.status === 'reading'
      ));
  const verificationMode =
    activeReview || handOffPending
      ? 'review'
      : verificationAllowed && savedReport
      ? 'saved'
      : null;
  const savedAnchors = useSavedReportAnchors(
    verificationMode === 'saved' ? savedReport.id : null
  );
  const activeKey = activeReview?.key || null;
  const activeOrigin = activeReview?.origin || null;
  const activeInboxItem = activeReview?.inboxItemId || null;
  const activeFile = activeReview?.file || null;
  const reportDocument = React.useMemo(() => {
    if (verificationMode === 'saved') return savedDocument(savedReport?.id);
    if (activeKey) {
      return activeOrigin === 'inbox'
        ? inboxDocument(activeInboxItem)
        : uploadDocument({ key: activeKey, file: activeFile });
    }
    return handOffPending ? inboxDocument(inboxHandOff) : null;
  }, [
    verificationMode,
    savedReport?.id,
    activeKey,
    activeOrigin,
    activeInboxItem,
    activeFile,
    handOffPending,
    inboxHandOff
  ]);
  const savedVariants = formValues.variants;
  const nameVariant = React.useCallback(
    (findingId) =>
      variantLabel(
        (savedVariants || []).find((v) => v && v.findingId === findingId)
      ) || null,
    [savedVariants]
  );
  const verification = useVerificationView({
    mode: verificationMode,
    reading: choiceReading || activeReview?.reading || null,
    origin: activeOrigin === 'inbox' ? 'inbox' : 'upload',
    saved: verificationMode === 'saved' ? savedAnchors.answer : null,
    document: reportDocument,
    readOnly: readOnly || verificationMode === 'saved',
    nameVariant
  });
  verificationRef.current = verification;
  // The dialog goes full screen, and back, before the change is painted.
  React.useLayoutEffect(() => {
    onVerificationModeChange?.(verificationMode);
  }, [verificationMode, onVerificationModeChange]);
  // The saved Test's report is read-only: nothing on the form is saved while it is open.
  const formReadOnly = readOnly || verificationMode === 'saved';
  // Whom a saved record of one person's part of a report about several is for (its individualKey).
  const savedForWhom =
    verificationMode === 'saved'
      ? forWhomOf({
          reading: {
            individualKey: savedReport?.exported?.labReport?.individualKey
          }
        })
      : null;
  // ...and nothing on it is changed either: the Test's own fields take no edit while it is open,
  // which would otherwise be kept and saved by the next Save after "Close the report" (review of
  // the view; plan D6, "the Test as saved").
  const fieldsLocked = verificationMode === 'saved';
  // THE GROUPS (TGCLOUD-1868, plan D3, D4). The reading applied to the form is confirmed part by
  // part where each part is on it: the gene list in Genes tested, each report variant's identity
  // and its classification on its tile, the overall result in Result. Values the reader was not
  // confident of arrive empty and are entered there. Save waits for every part and every
  // acknowledgement (the footer says which); the save sends each confirmation once.
  const checks = useReadingChecks({
    review: appliedReview,
    form: formValues,
    view: verification,
    readOnly: formReadOnly
  });
  checksRef.current = checks;
  // "Open report" on one of this Test's lab reports opens the view on it, unless a report is being
  // checked here already, or the form holds changes not saved yet: then it opens in a new tab, as
  // it always did. The view shows "the Test as saved, beside the report it was read from" (D6), and
  // a form changed since would show the change as saved, its marks pointing where the saved value
  // is printed (review of the view).
  const changedSinceSaved = React.useMemo(() => {
    const changed = unsavedTestChanges({ form: formValues, saved: lastSaved });
    return (
      changed.fields.size > 0 ||
      changed.genes.size > 0 ||
      changed.variants.size > 0 ||
      (formValues.genesTestedList?.status || null) !==
        (lastSaved.genesTestedList?.status || null) ||
      (formValues.genesTested || []).length !==
        (lastSaved.genesTested || []).length ||
      (formValues.variants || []).length !== (lastSaved.variants || []).length
    );
  }, [formValues, lastSaved]);
  const openSavedReport =
    verificationAllowed &&
    !activeReview &&
    !handOffPending &&
    !changedSinceSaved
      ? (labReportId, exported) =>
          setSavedReport({ id: String(labReportId), exported })
      : undefined;
  // The Test value a place in the report is about, drawn with the theme's ring while selected.
  const isHighlighted = (target) =>
    verification.active && verification.highlighted.has(target);
  // The saved report by its signed link, as "Open report" always opened it.
  const openSignedReport = (labReportId) =>
    openReportInNewTab(labReportId).catch((err) =>
      setSnack({
        status: true,
        msg: describeTestResultError(err, t('The report could not be opened.'))
          .message,
        severity: 'error'
      })
    );

  React.useEffect(() => {
    if (!patientDob) return;
    const nextAge = computeAgeWhenTested(formValues.dateRequested);
    setFormValues((prev) => {
      const currentAge =
        prev.ageWhenTested === undefined ? '' : prev.ageWhenTested;
      if (nextAge === '' && currentAge === '') return prev;
      if (nextAge === currentAge) return prev;
      return { ...prev, ageWhenTested: nextAge };
    });
  }, [patientDob, computeAgeWhenTested, formValues.dateRequested]);

  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    setOpen(true);
  };

  const deleteNote = async (e) => {
    setLoading(true);

    const dep = await getDependencies(
      user.familyId,
      model._id,
      theme.dateFormat,
      t
    );
    if (dep.length !== 0) {
      setSnack({
        status: true,
        msg: t('Associated record exists; check the {{value}}', {
          value: dep[0]
        }),
        severity: 'error'
      });
      setLoading(false);

      return;
    }
    axios
      .delete(`/clinical-notes/note`, {
        params: {
          _id: model._id
        }
      })
      .then(async () => {
        await refreshPedigreeLabels?.();
        setSnack({
          status: true,
          msg: t('Record deleted'),
          severity: 'success'
        });
        handleCloseModal();
        handleClose({ exit: true });
      })
      .catch((err) => {
        setSnack({
          status: true,
          msg: t('Delete failed! {{err}}', { err }),
          severity: 'error'
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const isDateDueValid = () =>
    !formValues.dateRequested ||
    !formValues.dateResultDue ||
    moment(formValues.dateRequested) <=
      moment(formValues.dateResultDue).add('1', 'day');

  const isDateResultReceivedValid = () =>
    !formValues.dateRequested ||
    !formValues.dateResultReceived ||
    moment(formValues.dateRequested) <=
      moment(formValues.dateResultReceived).add('1', 'day');

  // A report dated before a new Test's untouched default date requested: the save clears that date
  // (requestDateIsDefault), so the result is not "received before it was requested".
  const reportDateOfApplied =
    appliedReview?.reading?.proposal?.dateResultReceived;
  const requestDateWillClear =
    !!appliedReview &&
    requestDateIsDefault &&
    !!dayOf(reportDateOfApplied) &&
    !!dayOf(formValues.dateRequested) &&
    dayOf(reportDateOfApplied) < dayOf(formValues.dateRequested);

  const validateForm = (values) => {
    const errs = {};

    if (!values.testName?.trim()) {
      errs.testName = t('Test Name is required');
    }

    if (!values.dateRequested && !values.dateResultReceived) {
      errs.dateRequested = t(
        'Either Date Requested or Date Result Received is required'
      );
      errs.dateResultReceived = t(
        'Either Date Requested or Date Result Received is required'
      );
    }

    if (values.testResult?.trim() && !values.dateResultReceived) {
      errs.dateResultReceived = t('Required when Test Result is provided');
    }

    if (!isDateDueValid()) {
      errs.dateResultDue = t('Test cannot be due before it was requested');
    }

    if (!requestDateWillClear && !isDateResultReceivedValid()) {
      errs.dateResultReceived =
        errs.dateResultReceived ||
        t("Test can't be received before being requested");
    }

    setError((prev) => {
      const futureDateErrors = Object.fromEntries(
        Object.entries(prev).filter(([, v]) => v === true)
      );
      return { ...futureDateErrors, ...errs };
    });
    return errs;
  };

  // After a test is saved, ensure a genotype record exists for each gene
  // referenced by the test's variants and append the variants there. The
  // genotype endpoint dedupes by (gene, variantG, variantC, variantP) so
  // re-saves don't create duplicates.
  //
  // The person's genotypes are then read back onto their row in memberRecords,
  // with the pedigree autosave held until they are there. Without that the
  // row kept the pre-push genotypes, and the next unrelated autosave in the
  // family wrote them back over the pushed variants (memberGenotypesRow.js).
  // The Test save's answer says what the server copied on its own
  // (`genotypeCopy`); the row is read back when that landed even if every
  // push here is refused.
  const syncTestVariantsToGenotypes = async (payload, savedTest) => {
    const userId = user?.user_id || user?._id;
    if (!userId || !familyMemberId) return;
    // A Test about a pregnancy is the mother's note and its variants are the fetus's: never copied
    // to her genotypes, by the server's copy or by this push (TGCLOUD-1868 B7).
    if (carriesPrenatalScope(payload)) return;

    // A variant from a lab report is copied by the SERVER, with its transcript in variantC and the
    // report it came from (sourceTestResultId, sourceFindingId): pushed again from here, without
    // them, it would be a second genotype row for the same variant. Only what the server copied is
    // read back for it (`serverStored`).
    const allVariants = (
      Array.isArray(payload?.variants) ? payload.variants : []
    ).filter((v) => !isReportVariant(v));
    const serverStored = savedTest?.genotypeCopy?.genotypes;
    const variantsByGene = new Map();
    allVariants.forEach((v) => {
      const gene = (v?.gene || '').trim();
      if (!gene) return;
      if (!variantsByGene.has(gene)) variantsByGene.set(gene, []);
      variantsByGene.get(gene).push(v);
    });
    if (variantsByGene.size === 0 && !(serverStored || []).length) return;

    const sourceTestId = savedTest?._id || payload?._id;
    const sourceTestName = payload?.testName;
    const sourceTestDate =
      payload?.dateResultReceived || payload?.dateRequested || null;

    const buildVariantPayload = (gene, variants) =>
      variants
        .map((v) => ({
          gene,
          variantG: v.variantG || '',
          variantC: v.variantC || '',
          variantP: v.variantP || '',
          labInterpretation: v.variantInterpretation || '',
          // Inherited vs acquired. Absent means 'unknown', which the
          // analyzer treats as potentially heritable.
          origin: v.origin || 'unknown',
          sourceTestId,
          sourceTestName,
          sourceTestDate
        }))
        .filter(
          (v) => v.variantG || v.variantC || v.variantP || v.labInterpretation
        );

    // Best-effort, as before: a refused push does not fail the Test save,
    // which has already landed by the time this runs.
    await pushVariantsOntoMemberRow({
      rowSync,
      user_id: userId,
      familyMemberId,
      isProband,
      pushes: Array.from(variantsByGene.entries()).map(([gene, variants]) => ({
        gene,
        variants: buildVariantPayload(gene, variants)
      })),
      serverStored
    }).catch((err) => {
      console.error('Failed to push test variants to genotypes:', err);
    });
  };

  // The Test as it would be saved, or null (with the errors shown) when it does not validate.
  const buildTestPayload = () => {
    const hasFutureDateErrors = Object.values(error).some((v) => v === true);
    const validationErrors = validateForm(formValues);
    if (Object.keys(validationErrors).length > 0 || hasFutureDateErrors) {
      document.getElementById('modaltop')?.scrollIntoView();
      return null;
    }
    const requestedByPayload =
      formValues.requestedBy && formValues.requestedBy.length > 0
        ? formValues.requestedBy
            .map((id) => staffMembers.find((member) => member.userId === id))
            .filter(Boolean)
        : [];

    const editorHasContent =
      !!currentVariant.gene ||
      !!currentVariant.variantG ||
      !!currentVariant.variantC ||
      !!currentVariant.variantP ||
      !!currentVariant.variantInterpretation ||
      !!currentVariant.dateLastReviewed;

    let mergedVariants = formValues.variants || [];
    let genesTested = formValues.genesTested;
    if (isEditingVariant && editorHasContent) {
      mergedVariants = mergedVariants.map((v, i) =>
        i === editingVariantIndex ? { ...currentVariant } : v
      );
    } else if (
      !isEditingVariant &&
      editorHasContent &&
      !mergedVariants.some((v) => sameEditorEntry(v, currentVariant))
    ) {
      mergedVariants = [...mergedVariants, { ...currentVariant }];
      genesTested = withGeneListed(
        genesTested,
        currentVariant.gene,
        variantGeneIdsRef.current
      );
    }

    return {
      ...formValues,
      // Only a Test that lists genes (or listed them) sends the list, so a Test saved without
      // any is sent exactly as it always was.
      ...(genesTested !== undefined ? { genesTested } : {}),
      // A lab report was uploaded before the form re-rendered with the id minted for it.
      ...(testIdRef.current && !formValues._id
        ? { _id: testIdRef.current }
        : {}),
      variants: mergedVariants,
      requestedBy: requestedByPayload,
      // The report applied to this form (useLabReportReview): the save records it, with each
      // group of its reading confirmed once and when (TGCLOUD-1868 B4), and, from the view, the
      // review it was checked in and whether the values were checked another way because the
      // report could not be shown. Absent on every other save, which is then exactly what it
      // always was. The list state rides in the Test body (genesTestedList). The wrong-patient
      // acknowledgement is sent only where the reading needs one (decision 29: a real
      // disagreement, never information alone).
      ...(appliedReview
        ? {
            labReportApplication: {
              token: appliedReview.reading?.token,
              ...(requiresIdentityAcknowledgement(
                appliedReview.reading?.identity
              )
                ? {
                    acknowledgeIdentityMismatch:
                      appliedReview.acknowledged === true
                  }
                : {}),
              requestDateIsDefault: requestDateIsDefault === true,
              confirmations: checks.confirmations,
              ...verification.applicationFields
            }
          }
        : {})
    };
  };

  // Save the Test, and what follows every save: the attachment deletes it now allows and the
  // variant push to genotypes. Resolves with the response, or null when the server did not
  // answer 200.
  //
  // A save that applied a lab report answers with what it recorded (`labReport`), and with the
  // dates as saved: the default-request-date rule may have cleared the date requested (and an age
  // worked out from it) or left the report's date out of the date received. The form takes them
  // back, so nothing it holds, the old default above all, is written again.
  const persistTest = (parsePayload) =>
    axios.put(APICONSTANTS.test, parsePayload).then(async (res) => {
      if (res.status !== 200) return null;
      attachmentChanges.commit(parsePayload.fileAttachments, familyMemberId);
      // The review this save recorded ends its telemetry session as saved (TGCLOUD-1868 D7),
      // before the review goes.
      if (parsePayload.labReportApplication) {
        verificationRef.current?.finish('saved');
      }
      let saved = parsePayload;
      const applied = res.data?.labReport;
      if (applied) {
        const dates = applied.saved || {};
        saved = { ...parsePayload, ...dates };
        setFormValues((prev) => ({ ...prev, ...dates }));
        setRequestDateIsDefault(false);
        setFromReport(NO_MARKS);
        // The review goes once the form is closed (handleSubmit), not here: taken off now, the view
        // collapsed back to the 850px modal while the genotype copy and the labels were still
        // being read back, and the Save it put back in the Grid was a new one, enabled, so a
        // second click saved the Test again with no report (review of the view).
        notifyTestResultsChanged({ testNoteId: parsePayload._id });
      }
      // Saved: this is the Test as last saved now.
      setLastSaved(saved);
      await syncTestVariantsToGenotypes(saved, res.data);
      return res;
    });

  // What the save of an applied report says beyond "saved": a date the rule changed, and a
  // record the server could not finish (applying the same report again finishes it).
  // A report from the lab report inbox (Phase 3) says whether its inbox item was linked: an item
  // left unlinked stays matched there, and handing it to this Test again finishes it.
  const labReportSaveNotes = (applied) => {
    if (!applied) return [];
    const dates = applied.dates || {};
    return [
      applied.inbox?.linked === true
        ? t(
            'The lab report is recorded on this Test, and marked as applied in the Lab Report Inbox.'
          )
        : t('The lab report is recorded on this Test.'),
      applied.inbox?.linked === false
        ? t(
            'It was not marked as applied in the Lab Report Inbox, where it still waits: open it from there and apply it to this Test again to finish.'
          )
        : null,
      dates.dateRequestedCleared
        ? t(
            'The date requested was cleared: it was only the form’s default, and the report is dated earlier.'
          )
        : null,
      dates.dateResultReceivedNotFilled
        ? t(
            'The report’s date was not recorded as the date received: it is before the date requested.'
          )
        : null,
      applied.commitFailed
        ? t(
            'The lab report record was not finished. Apply the same report again to finish it.'
          )
        : null
    ].filter(Boolean);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Save waits for every part of an applied reading and every acknowledgement, and while whose
    // part of a report about several people this Test is is still being chosen (the footer says
    // which): the button is disabled, and so is this.
    if (checks.active && checks.blockers.length) return Promise.resolve();
    if (choiceWaits.length) return Promise.resolve();
    const parsePayload = buildTestPayload();
    if (!parsePayload) return Promise.resolve();
    setSaveError(null);

    return persistTest(parsePayload)
      .then(async (res) => {
        if (res) {
          // The report this save recorded is done with once the form is closed: until then the
          // view, and its Save in the footer, stay as they were while it was saving. A refresh that
          // fails leaves the form open, with the report recorded and so taken off.
          const finishReview = () => {
            if (res.data?.labReport) labReport.finishApplied();
          };
          try {
            await refreshPedigreeLabels?.();
          } catch (err) {
            finishReview();
            throw err;
          }
          handleClose({ exit: true });
          finishReview();
          // A variant another Test holds with a different origin keeps that Test's call
          // (genotypeVariantService.mergeSourceAndOrigin); the server says which, and so does this.
          const notApplied = keptVariantsMessage(
            res.data?.genotypeCopy?.kept,
            t
          );
          const notes = labReportSaveNotes(res.data?.labReport);
          // The server's copy skipped a Test about a pregnancy (TGCLOUD-1868 B7).
          const personName = `${data?.firstName || ''} ${
            data?.lastName || ''
          }`.trim();
          const notCopied =
            res.data?.genotypeCopy?.skipped === 'prenatal'
              ? personName
                ? t(
                    'Not copied to {{personName}}’s genotypes: this Test is about a pregnancy.',
                    { personName }
                  )
                : t(
                    'Not copied to this person’s genotypes: this Test is about a pregnancy.'
                  )
              : null;
          const warn =
            !!notApplied ||
            !!res.data?.labReport?.commitFailed ||
            notes.length > 1;
          setSnack(
            notApplied || notCopied || notes.length
              ? {
                  status: true,
                  msg: [t('Saved.'), ...notes, notCopied, notApplied || null]
                    .filter(Boolean)
                    .join(' '),
                  severity: warn ? 'warning' : 'success'
                }
              : {
                  status: true,
                  msg: t('Successfully saved'),
                  severity: 'success'
                }
          );
        } else {
          setSnack({
            status: true,
            msg: t('Upload failed!'),
            severity: 'error'
          });
        }
      })
      .catch((err) => {
        // A refusal the server explained (a Test record the save check refused, a lab report
        // application it could not accept) is said in its words, with every reason, and stays on
        // the form beside Save; the form stays open with everything in it.
        if (err?.response?.data?.message) {
          // A reason about the reading names its groups and values in words (TGCLOUD-1868), and a
          // refusal of a reading for one person of a report says it for them (Phase E4).
          const described = describeTestResultError(
            err,
            t('The Test could not be saved.'),
            {
              ...(checks.active
                ? { nameGroup: checks.nameGroup, nameValue: checks.nameValue }
                : {}),
              ...(appliedReview?.individual
                ? { individual: appliedReview.individual }
                : {})
            }
          );
          setSaveError(described);
          // A report being checked: closed now, its telemetry session says the save was refused
          // (useVerificationSession; a no-op with no session).
          verificationRef.current?.counters?.saveRefused?.();
          setSnack({
            status: true,
            msg: t('Not saved. {{message}}', { message: described.message }),
            severity: 'error'
          });
          return;
        }
        setSnack({
          status: true,
          msg: t('Upload failed! {{err}}', { err }),
          severity: 'error'
        });
      });
  };

  // ── Lab reports (TGCLOUD-1866, Phase 2 rework) ──

  // APPLIED ON OPEN (TGCLOUD-1868, plan D3). A reading merges into the form the moment it arrives,
  // by applyProposal's rules: an empty field is filled, genes and variants are merged, and every
  // contradiction stays as the Test holds it until the clinician chooses (withChoice). Where the
  // report's gene list is taken as printed, the list state "every gene the laboratory analysed" is
  // proposed with it (proposedListState). The plan it was merged by is kept on the review, so a
  // choice can be made again, "Applying to this Test" can say what saving will fill, and the report
  // can come off again. Nothing is written: the Save that follows records it.
  //
  // `matched` is withheldMatches': the Test's own variant each finding is, where the report's
  // description was withheld and could only be compared by digest. The form is read as it stands
  // when the reading is applied (formValuesRef), since that comparison is awaited.
  const requestDateIsDefaultRef = React.useRef(requestDateIsDefault);
  requestDateIsDefaultRef.current = requestDateIsDefault;
  const reviewsRef = React.useRef(labReport.reviews);
  reviewsRef.current = labReport.reviews;
  const applyReading = (review, matched = null) => {
    const formNow = formValuesRef.current;
    const plan = planApplication({
      form: formNow,
      proposal: review.reading?.proposal || {},
      requestDateIsDefault: requestDateIsDefaultRef.current,
      // What the reader was not confident of arrives empty, the Test's own value there included,
      // to be entered from the report (TGCLOUD-1868 B1, D3).
      withheld: (Array.isArray(review.reading?.lowConfidence)
        ? review.reading.lowConfidence
        : []
      ).map((l) => l && l.path),
      matched
    });
    const { form: merged, applied } = applyPlan(formNow, plan, {});
    const listState = proposedListState({
      reading: review.reading,
      form: merged
    });
    const next = listState ? { ...merged, genesTestedList: listState } : merged;
    setFormValues(next);
    setFromReport((prev) => ({
      fields: new Set([...prev.fields, ...applied.fields]),
      genes: new Set([...prev.genes, ...applied.genes]),
      findings: new Set([...prev.findings, ...applied.findings])
    }));
    if (next.testName?.trim()) {
      setError((prev) => {
        const { testName: _, ...rest } = prev;
        return rest;
      });
    }
    if (applied.fields.has('dateResultReceived')) clearEitherDateErrors();
    labReport.markApplied(review.key, {
      plan,
      // What the form held for the gene list before, for taking the report off again.
      before: {
        genesTested: formNow.genesTested,
        genesTestedList: formNow.genesTestedList
      },
      listState,
      summary: {
        fields: applied.fields.size,
        genes: applied.genes.size,
        findings: applied.findings.size
      }
    });
    markUnsaved();
  };

  // One report at a time: the save carries one token, so a reading that arrives while another is
  // applied waits, and is applied once that one is saved or dismissed. The ref keeps a re-render,
  // or StrictMode's second effect, from applying one twice.
  const waitingReview =
    verificationAllowed && !appliedReview && !formReadOnly
      ? labReport.reviews.find((r) => r.status === 'ready' && !!r.reading) ||
        null
      : null;
  const appliedReadings = React.useRef(new Set());
  React.useEffect(() => {
    if (!waitingReview || appliedReadings.current.has(waitingReview.key)) {
      return;
    }
    appliedReadings.current.add(waitingReview.key);
    const review = waitingReview;
    // A withheld description is compared with the Test's own variants first, by digest, so the
    // report's finding merges into the one the Test holds rather than being added beside it
    // (withheldMatches.js). Nothing to compare: applied at once, as it always was.
    if (
      !needsWithheldMatching({
        reading: review.reading,
        form: formValuesRef.current
      })
    ) {
      applyReading(review);
      return;
    }
    withheldMatchesOf({ reading: review.reading, form: formValuesRef.current })
      .catch(() => new Map())
      .then((matched) => {
        // Dismissed, or applied some other way, while it was compared: nothing to apply.
        const still = reviewsRef.current.find((r) => r.key === review.key);
        if (still && still.status === 'ready') applyReading(still, matched);
      });
    // applyReading reads the form as it stands when the reading arrives: the ref is the guard.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitingReview?.key]);

  // A contradiction chosen ON THE FORM: the report's side, or the Test's own back. Chosen again,
  // it changes again. "From the report" follows the choice.
  const chooseOnForm = (review, patch) => {
    const items = conflictsOf(
      review?.application?.plan || { fields: [], genes: [], variants: [] }
    );
    const chosen = Object.entries(patch || {})
      .map(([id, choice]) => ({ item: items.find((c) => c.id === id), choice }))
      .filter(({ item }) => !!item);
    if (!chosen.length) return;
    setFormValues((prev) =>
      chosen.reduce(
        (form, { item, choice }) => withChoice(form, item, choice),
        prev
      )
    );
    setFromReport((prev) => {
      const next = {
        fields: new Set(prev.fields),
        genes: new Set(prev.genes),
        findings: new Set(prev.findings)
      };
      for (const { item, choice } of chosen) {
        const [set, value] = item.field
          ? [next.fields, item.field]
          : item.key
          ? [next.genes, item.key]
          : [next.findings, item.findingId];
        if (choice === 'report') set.add(value);
        else set.delete(value);
      }
      return next;
    });
    if (chosen.some(({ item }) => item.field === 'dateResultReceived')) {
      clearEitherDateErrors();
    }
    labReport.setChoices(review.key, patch);
    markUnsaved();
  };

  const dismissReview = (review) => {
    takeOffReport(review);
    labReport.dismiss(review.key);
  };

  // A value of a report variant entered on its card: a low-confidence value of its identity or
  // classification, typed or chosen (LowConfidenceField). A transcript is kept trimmed, as the
  // variant editor keeps it.
  const setReportVariantField = (findingId, field, value) => {
    const next =
      field === 'transcript' && typeof value === 'string'
        ? value.trim() || null
        : value;
    setFormValues((prev) => ({
      ...prev,
      variants: (prev.variants || []).map((v) =>
        v && v.findingId === findingId ? setPath(v, field, next) : v
      )
    }));
    markUnsaved();
  };

  // What the gene rows are, said on the gene list card (TGCLOUD-1868 B2), or in "Genes tested"
  // outside a review (GeneListStateField).
  const setGenesTestedListState = (status) => {
    if (appliedReview) enteredFor(appliedReview.key).listState = true;
    setFormValues((prev) => ({ ...prev, genesTestedList: { status } }));
    markUnsaved();
  };
  // How many genes the applied report states: the Test's as saved, since the save keeps the stored
  // count whatever the form sends (testRecord.js), and the form's state is set without it.
  const storedStatedCount = Number.isInteger(
    lastSaved?.genesTestedList?.statedCount
  )
    ? lastSaved.genesTestedList.statedCount
    : null;
  // What a gene this Test does not list reads as, as the form would save it (plan B2's mirror).
  const unlistedState = unlistedGeneStateOf({
    ...formValues,
    genesTestedList: formValues.genesTestedList?.status
      ? {
          status: formValues.genesTestedList.status,
          ...(storedStatedCount !== null
            ? { statedCount: storedStatedCount }
            : {})
        }
      : null
  });

  // A report withdrawn from the Result section: the form drops what the server removed from the
  // stored Test, where the form still holds it as loaded, so a later Save cannot write it back, and
  // takes every gene row and variant from the report as the server left it, so the form still saves
  // (withdrawalOntoForm). What that takes back of the form's unsaved changes, the dialog says first.
  const unsavedChangesFor = (labReportId) =>
    unsavedRowsFromReport(formValues, model || {}, labReportId);
  const takeWithdrawal = (answer, labReportId) => {
    setFormValues((prev) =>
      withdrawalOntoForm(prev, answer, { stored: model || {}, labReportId })
    );
    // The stored Test changed too: what is not saved is measured from it as it now is.
    setLastSaved((prev) =>
      withdrawalOntoForm(prev, answer, { stored: prev, labReportId })
    );
  };

  // What is not saved yet, drawn only while a lab report is applied (see UNSAVED CHANGES above).
  const unsaved = React.useMemo(
    () =>
      appliedReview
        ? unsavedTestChanges({ form: formValues, saved: lastSaved })
        : NO_CHANGES,
    [appliedReview, formValues, lastSaved]
  );
  // A Test field holding an outlined input (a text field, a select, a date picker), drawn as an
  // unsaved change; and one holding a control with no outline (a checkbox, a switch).
  // Ringed, too, while the report's selection is about the field (THE VERIFICATION VIEW).
  const unsavedSx = (name) => ({
    ...unsavedFieldSx(unsaved.fields.has(name)),
    ...highlightSx(isHighlighted(fieldTarget(name)))
  });
  const unsavedControl = (name) => unsavedControlSx(unsaved.fields.has(name));
  // A Test field's container, named for the verification view: a box selected in the report
  // scrolls the form to the field it is about.
  const targetOf = (name) => ({
    'data-verification-target': fieldTarget(name),
    'data-highlighted': isHighlighted(fieldTarget(name)) ? 'true' : undefined
  });

  // "from the report" beside a Test field a lab report filled, until it is changed or saved; where
  // the report prints it, while the verification view is open (AnchorMark: "Show in the report",
  // or why it has no place there); and, said rather than shown, that the field is changed and not
  // saved, while it is gold.
  const fieldMark = (name) => (
    <>
      {fromReport.fields.has(name) && <FromReportMark sx={{ ml: 1 }} />}
      <AnchorMark target={fieldTarget(name)} label={t(FIELD_LABELS[name])} />
      {unsaved.fields.has(name) && <UnsavedChangeNote />}
    </>
  );

  // The variant tiles for one gene, in the genes tested table's expanded row and in Variants.
  const variantTiles = (entries) =>
    entries.map(({ variant, index }) => (
      <SavedVariantTile
        key={variant.findingId || index}
        variant={variant}
        fromReport={
          !!variant.findingId && fromReport.findings.has(variant.findingId)
        }
        unsaved={unsaved.variants.has(index)}
        isEditing={editingVariantIndex === index}
        onEdit={formReadOnly ? undefined : () => handleEditVariant(index)}
        onDelete={formReadOnly ? undefined : () => handleDeleteVariant(index)}
      />
    ));

  // The lab report reviews, and where a report sent to the inbox went. Drawn at the top of a Test
  // opened from the inbox (that is what the clinician came to do), and beside the attachments
  // otherwise, where the upload that read them sits.
  const labReportPanels = readsLabReports ? (
    <>
      {sentToInbox.map((sent) => (
        <Grid size={12} key={sent.key}>
          <Alert
            severity="success"
            data-testid="lab-report-sent-to-inbox"
            onClose={() =>
              setSentToInbox((prev) => prev.filter((s) => s.key !== sent.key))
            }
          >
            {sentToInboxLines(
              sent.answer,
              {
                attachmentRemoved: sent.attachmentRemoved,
                changed: sent.changed.map((f) => t(FIELD_LABELS[f]) || f)
              },
              t
            ).map((line) => (
              <Typography key={line} variant="body2">
                {line}
              </Typography>
            ))}
          </Alert>
        </Grid>
      ))}
      {labReport.reviews.map((review) => (
        <LabReportApply
          key={review.key}
          review={review}
          otherApplied={!!appliedReview && appliedReview.key !== review.key}
          onAcknowledge={(checked) =>
            labReport.setAcknowledged(review.key, checked)
          }
          onAcknowledgeWarning={(warning, checked) =>
            labReport.setWarningAcknowledged(review.key, warning, checked)
          }
          onChoose={(patch) => chooseOnForm(review, patch)}
          onDismiss={() => dismissReview(review)}
          onSendToInbox={
            mayUseInbox && review.origin !== 'inbox'
              ? () => sendReviewToInbox(review)
              : undefined
          }
          testScope={testScope}
          onChooseIndividual={(individual) =>
            labReport.chooseIndividual(review.key, individual, {
              testScope: {
                pregnancyId: formValuesRef.current.pregnancyId,
                fetusId: formValuesRef.current.fetusId
              }
            })
          }
          onSendChoiceToInbox={
            mayUseInbox && review.origin !== 'inbox'
              ? () => sendChoiceReviewToInbox(review)
              : undefined
          }
        />
      ))}
    </>
  ) : null;

  // The lab report reviews go at the top of the form when it was opened from the inbox (that is
  // what the clinician came to do) and whenever a report is checked beside it; beside the
  // attachments otherwise, where the upload that read them sits.
  const panelsAtTop = !!inboxHandOff || verification.mode === 'review';

  // The left pane: the report, with what the view offers about it.
  const reportPane = verification.active ? (
    <ReportPane
      view={verification}
      title={
        verification.mode === 'saved'
          ? t('Lab report, as applied to this Test')
          : activeOrigin === 'inbox' || (!activeReview && handOffPending)
          ? t('Lab report, from the Lab Report Inbox')
          : t('Lab report')
      }
      actions={
        verification.mode === 'saved' ? (
          <Button
            size="small"
            variant="outlined"
            startIcon={<OpenInNewIcon />}
            onClick={() => openSignedReport(savedReport.id)}
          >
            {t('Open in a new tab')}
          </Button>
        ) : null
      }
    />
  ) : null;

  // A report checked beside the Test: the footer holds the buttons (THE FOOTER below).
  const inReview = verification.mode === 'review';
  // A refused save, in the server's words with every reason, beside Save.
  const saveErrorAlert = saveError ? (
    <Alert severity="error" data-testid="save-error">
      {saveError.message}
      {(saveError.reasons || []).map((r, i) => (
        <Typography key={i} variant="body2" component="div">
          {r}
        </Typography>
      ))}
    </Alert>
  ) : null;
  // Save waits for files still uploading, and for every part of an applied reading and every
  // acknowledgement (useReadingChecks.blockers: the footer says which).
  const saveButtonProps = uploadingFiles
    ? { disabled: true, title: t('Waiting for files to finish uploading') }
    : (checks.active && checks.blockers.length) || choiceWaits.length
    ? { disabled: true, 'data-waiting': 'true' }
    : undefined;
  const buttons = (
    <ModalButtons
      isEditing={isEditing}
      hideContinueAdding={true}
      onClick={handleSubmit}
      intermediateBtnLabel="Delete"
      intermediateAction={isEditing && !formReadOnly ? handleOpenModal : null}
      handleClose={handleClose}
      addLabel={`Save New Test`}
      hideSaveButton={formReadOnly}
      saveButtonProps={saveButtonProps}
    />
  );

  const testPane = (
    <form className="user-form">
      <ClinicalNoteDeleteModal
        loading={loading}
        open={open}
        handleCloseModal={handleCloseModal}
        onConfirm={deleteNote}
        title="Are you sure you want to delete this Test ?"
        content={t(
          'Warning: This action will permanently delete this Test. Once deleted, this information will be permanently removed and cannot be restored.'
        )}
      />
      <Grid container spacing={2}>
        {verification.mode === 'saved' && (
          <Grid size={12}>
            <Box
              data-testid="saved-report-note"
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 1,
                mb: 1
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: 'text.secondary', flex: 1, minWidth: 200 }}
              >
                {t(
                  'The Test as saved, beside the report it was read from. Nothing here is saved: close the report to change the Test.'
                )}
              </Typography>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                onClick={() => setSavedReport(null)}
              >
                {t('Close the report')}
              </Button>
            </Box>
            {/* A record of one person's part of a report about several (TGCLOUD-1868, Phase E4)
                says whose it is, as the reading did before it was saved. */}
            {savedForWhom && (
              <Typography
                variant="body2"
                data-testid="saved-test-is-for"
                sx={{ fontWeight: 700, mb: 1 }}
              >
                {testIsForText(savedForWhom)}
              </Typography>
            )}
            {/* ...and the report beside it marks everyone else's rows apart (Phase E routine call). */}
            {(savedAnchors.answer?.otherIndividuals || []).length > 0 && (
              <Typography
                variant="caption"
                component="div"
                data-testid="saved-others-marked"
                sx={{ color: 'text.secondary', mt: -0.5, mb: 1 }}
              >
                {t(OTHERS_MARKED_SAVED_TEXT)}
              </Typography>
            )}
            <SavedReportChecks
              status={savedAnchors.status}
              groups={savedAnchors.answer?.groups}
              variants={formValues.variants}
              unverifiable={
                savedReport?.exported?.labReport?.provenance?.unverifiable
              }
            />
          </Grid>
        )}
        {panelsAtTop && labReportPanels}
        {inboxUnavailable && (
          <Grid size={12}>
            <Alert severity="info" data-testid="lab-report-inbox-unavailable">
              {t(
                'This Test was opened from the Lab Report Inbox, but the report cannot be applied here: {{reason}}.',
                { reason: inboxUnavailable }
              )}
            </Alert>
          </Grid>
        )}
        {/* ── Request ── */}
        <SectionHeading first title={t('Request')} />
        {readOnly && (
          <Grid size={12}>
            <Alert severity="info" data-testid="test-read-only">
              {t(
                'You have read-only access. This Test can be viewed, not changed.'
              )}
            </Alert>
          </Grid>
        )}
        <Grid
          id="modaltop"
          size={12}
          sx={unsavedSx('testName')}
          {...targetOf('testName')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel required>Test Name</FormLabel>
            {fieldMark('testName')}
          </Grid>
          <AutocompleteInput
            name="testName"
            value={formValues.testName || ''}
            options={testNameOptions}
            onChange={(newValue) => {
              const label = newValue ? newValue.label || newValue : '';
              handleChange({ target: { name: 'testName', value: label } });
              if (label) {
                setError((prev) => {
                  const { testName: _, ...rest } = prev;
                  return rest;
                });
                saveClinicalDefault('testNames', label).then(
                  setTestNameOptions
                );
              }
            }}
            onDelete={(option) =>
              deleteClinicalDefault('testNames', option.label).then(
                setTestNameOptions
              )
            }
            highlightErrorBorder={!!error.testName}
            helperText={error.testName}
            disabled={fieldsLocked}
          />
        </Grid>
        <Grid size={6} sx={unsavedSx('testType')} {...targetOf('testType')}>
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Reason for Test</FormLabel>
            {fieldMark('testType')}
          </Grid>
          <AutocompleteInput
            name="testType"
            value={formValues.testType || ''}
            options={testTypeOptions}
            onChange={(newValue) => {
              const label = newValue ? newValue.label || newValue : '';
              handleChange({ target: { name: 'testType', value: label } });
              if (label)
                saveClinicalDefault('testTypes', label).then(
                  setTestTypeOptions
                );
            }}
            onDelete={(option) =>
              deleteClinicalDefault('testTypes', option.label).then(
                setTestTypeOptions
              )
            }
            disabled={fieldsLocked}
          />
        </Grid>

        <Grid
          size={6}
          sx={unsavedSx('dateRequested')}
          {...targetOf('dateRequested')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Date Requested</FormLabel>
            {fieldMark('dateRequested')}
          </Grid>
          <DateInput
            name="dateRequested"
            value={asPickerDay(formValues.dateRequested)}
            disableFuture
            onChange={(val) =>
              handleChange({
                target: { name: 'dateRequested', value: val, type: 'date' }
              })
            }
            variant="outline"
            error={!!error.dateRequested}
            helperText={
              typeof error.dateRequested === 'string'
                ? error.dateRequested
                : t('Date cannot be in the future')
            }
            disabled={fieldsLocked}
          />
          {requestDateWillClear && (
            <Typography
              variant="caption"
              component="div"
              sx={{ color: 'warning.dark', mt: 0.5 }}
              data-testid="request-date-will-clear"
            >
              {t(
                'Saving clears this date: it is only this new Test’s default, and the lab report is dated earlier. Pick the date the test was requested to keep one.'
              )}
            </Typography>
          )}
        </Grid>
        <Grid
          size={6}
          sx={unsavedSx('ageWhenTested')}
          {...targetOf('ageWhenTested')}
        >
          <TextInput
            label="Age When Tested"
            name="ageWhenTested"
            type="number"
            value={formValues.ageWhenTested ?? ''}
            inputProps={{ min: 0, className: 'no-spinners' }}
            // Disabled (muted) only when an age is actually being
            // auto-calculated, i.e. DoB AND date requested both set.
            // Editable when either is missing so a known age can be
            // recorded directly.
            disabled={
              fieldsLocked || (!!patientDob && !!formValues.dateRequested)
            }
            onChange={
              fieldsLocked || (patientDob && formValues.dateRequested)
                ? undefined
                : (e) => {
                    const val = e.target.value;
                    const parsed = val === '' ? '' : Number(val);
                    if (val === '' || !Number.isNaN(parsed)) {
                      setFormValues((prev) => ({
                        ...prev,
                        ageWhenTested: val === '' ? '' : parsed
                      }));
                      setUnsavedChanges((prev) => ({ ...prev, edit: true }));
                    }
                  }
            }
          />
          {fieldMark('ageWhenTested')}
        </Grid>
        <Grid
          size={6}
          sx={unsavedSx('associatedConsent')}
          {...targetOf('associatedConsent')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Associated Consent</FormLabel>
            {fieldMark('associatedConsent')}
          </Grid>
          <AssociatedNote
            name="associatedConsent"
            handleChange={handleChange}
            value={formValues.associatedConsent}
            noteOptions={consentOptions}
            readOnly={fieldsLocked}
          />
        </Grid>

        {/* RequestedBy */}
        <Grid
          size={12}
          sx={unsavedSx('requestedBy')}
          {...targetOf('requestedBy')}
        >
          <FormControl component="fieldset" fullWidth>
            <Grid container spacing={1}>
              <Grid size={12}>
                <TextInput
                  label="Requested By"
                  name="requestedBy"
                  type="multiple-select"
                  value={formValues?.requestedBy || []}
                  onChange={handleChange}
                  options={allStaffMembers || []}
                  mapper={staffMembersMap || {}}
                  disabled={fieldsLocked}
                />
                {fieldMark('requestedBy')}
              </Grid>
            </Grid>
          </FormControl>
        </Grid>

        {/* ── Result ── */}
        <SectionHeading title={t('Result')} />
        <Grid size={6} sx={unsavedSx('lab')} {...targetOf('lab')}>
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Laboratory</FormLabel>
            {fieldMark('lab')}
          </Grid>
          <AutocompleteInput
            name="lab"
            value={formValues.lab || ''}
            options={labOptions}
            onChange={(newValue) => {
              const label = newValue ? newValue.label || newValue : '';
              handleChange({ target: { name: 'lab', value: label } });
              if (label)
                saveClinicalDefault('laboratories', label).then(setLabOptions);
            }}
            onDelete={(option) =>
              deleteClinicalDefault('laboratories', option.label).then(
                setLabOptions
              )
            }
            disabled={fieldsLocked}
          />
        </Grid>
        <Grid size={6} sx={unsavedSx('testCode')} {...targetOf('testCode')}>
          <TextInput
            label="Test Code"
            name="testCode"
            value={formValues.testCode || ''}
            onChange={handleChange}
            helperText={t(
              'The test’s code as the report prints it, such as a directory code (R208).'
            )}
            disabled={fieldsLocked}
          />
          {fieldMark('testCode')}
        </Grid>
        <Grid
          size={6}
          sx={unsavedSx('dateResultDue')}
          {...targetOf('dateResultDue')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Result Due Date</FormLabel>
            {fieldMark('dateResultDue')}
          </Grid>
          <DateInput
            value={asPickerDay(formValues.dateResultDue)}
            onChange={(e) =>
              setFormValues((prevValues) => ({
                ...prevValues,
                dateResultDue: e
              }))
            }
            variant="outline"
            minDate={asPickerDay(formValues.dateRequested)}
            error={!!error.dateResultDue}
            helperText={error.dateResultDue || ''}
            helperTextColour="red"
            disabled={fieldsLocked}
          />
        </Grid>
        <Grid
          size={6}
          sx={unsavedSx('dateResultReceived')}
          {...targetOf('dateResultReceived')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Date Result Received</FormLabel>
            {fieldMark('dateResultReceived')}
          </Grid>
          <DateInput
            value={asPickerDay(formValues.dateResultReceived)}
            onChange={(e) => {
              if (e) clearEitherDateErrors();
              unmark('fields', 'dateResultReceived');
              setFormValues((prevValues) => ({
                ...prevValues,
                dateResultReceived: e
              }));
            }}
            variant="outline"
            disableFuture
            minDate={
              requestDateWillClear
                ? undefined
                : asPickerDay(formValues.dateRequested)
            }
            error={!!error.dateResultReceived}
            helperText={error.dateResultReceived || ''}
            helperTextColour="red"
            disabled={fieldsLocked}
          />
        </Grid>

        <Grid
          size={12}
          sx={unsavedSx('testResult')}
          {...targetOf('testResult')}
        >
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Test Result</FormLabel>
            {fieldMark('testResult')}
          </Grid>
          <AutocompleteInput
            name="testResult"
            value={formValues.testResult || ''}
            options={testResultOptions}
            onChange={(newValue) => {
              const label = newValue ? newValue.label || newValue : '';
              handleChange({ target: { name: 'testResult', value: label } });
              // A Test result chosen where the conclusion was not read with confidence is
              // compared with what was read (TGCLOUD-1868 D3).
              if (checks.lowAt(OVERALL_RESULT_PATH)) {
                checks.commit(OVERALL_RESULT_PATH, label);
              }
              if (label)
                saveClinicalDefault('testResults', label).then(
                  setTestResultOptions
                );
            }}
            onDelete={(option) =>
              deleteClinicalDefault('testResults', option.label).then(
                setTestResultOptions
              )
            }
            disabled={fieldsLocked}
          />
          <OverallResultCard testResult={formValues.testResult} />
        </Grid>
        <Grid
          size={12}
          sx={unsavedSx('resultSummaryAsPrinted')}
          {...targetOf('resultSummaryAsPrinted')}
        >
          <TextField
            variant="outlined"
            fullWidth
            multiline
            name="resultSummaryAsPrinted"
            label={t('Result summary, as printed')}
            value={formValues.resultSummaryAsPrinted || ''}
            onChange={handleChange}
            helperText={t(
              'The laboratory’s conclusion in its own words. Test Result above is this site’s label for it.'
            )}
            disabled={fieldsLocked}
          />
          {fieldMark('resultSummaryAsPrinted')}
        </Grid>

        {/* The lab reports applied to this Test, once it exists (TGCLOUD-1866). */}
        {labReportsOn && savedTestId && (
          <LabReportsList
            testNoteId={savedTestId}
            familyMemberId={familyMemberId}
            isProband={isProband}
            readOnly={formReadOnly}
            onWithdrawn={takeWithdrawal}
            unsavedChangesFor={unsavedChangesFor}
            onOpenReport={openSavedReport}
          />
        )}

        {/* ── Test scope ── */}
        <SectionHeading
          title={t('Test scope')}
          caption={t(
            'An exome or a genome is recorded by its scope: list under genes tested only the genes the report names.'
          )}
        />
        <TestScopeField
          value={formValues.testScope}
          readOnly={formReadOnly}
          fromReport={fromReport.fields.has('testScope')}
          unsaved={unsaved.fields.has('testScope')}
          onChange={(next) => {
            unmark('fields', 'testScope');
            setFormValues((prev) => ({ ...prev, testScope: next }));
            markUnsaved();
          }}
        />

        {/* ── Genes tested ── */}
        <SectionHeading
          title={t('Genes tested')}
          caption={t(
            'Each gene the test covered, with what the laboratory states about its coverage and the methods used. A gene reads as nothing reportable only when the whole gene was completely covered and no variant is reported in it.'
          )}
        />
        {checks.active && (
          <Grid size={12}>
            <GeneListCard
              form={formValues}
              onSetListState={setGenesTestedListState}
              onAddGenes={handleAddGenes}
            />
          </Grid>
        )}
        {/* What the list is, outside a review too: the save checks it on every save, and a refusal
            for it must have an answer here (GeneListStateField; TGCLOUD-1868 review). */}
        {!checks.active && (
          <Grid size={12}>
            <GeneListStateField
              test={formValues}
              statedCount={storedStatedCount}
              readOnly={formReadOnly}
              onChange={setGenesTestedListState}
            />
          </Grid>
        )}
        <Grid size={12}>
          <GenesTestedTable
            genesTested={formValues.genesTested || []}
            variants={formValues.variants || []}
            readOnly={formReadOnly}
            fromReport={fromReport.genes}
            unsaved={unsaved.genes}
            onAddGenes={handleAddGenes}
            onChangeGene={handleChangeGene}
            onRemoveGene={handleRemoveGene}
            renderVariants={variantTiles}
            unlistedState={unlistedState}
          />
        </Grid>

        {/* ── Variants ── */}
        <SectionHeading
          title={t('Variants')}
          caption={t(
            'Grouped by gene. Adding a variant in a gene also lists the gene under genes tested.'
          )}
        />
        <Grid size={12}>
          <VariantsByGene
            variants={formValues.variants || []}
            genesTested={formValues.genesTested || []}
            readOnly={formReadOnly}
            fromReport={fromReport.findings}
            unsaved={unsaved.variants}
            editingIndex={editingVariantIndex}
            onEdit={handleEditVariant}
            onDelete={handleDeleteVariant}
            onAddInGene={handleAddVariantInGene}
            onListGene={handleListGene}
            renderChecks={
              checks.active
                ? (variant) => (
                    <VariantGroupCards
                      variant={variant}
                      onSetField={setReportVariantField}
                      interpretationOptions={VARIANT_INTERPRETATION_OPTIONS}
                    />
                  )
                : undefined
            }
          />
          <FindingsNotOnTest />
        </Grid>

        {!formReadOnly && (
          <>
            <Grid ref={variantEditorRef} size={12}>
              <Typography
                component="h4"
                variant="subtitle2"
                sx={{ fontWeight: 700, mb: 1 }}
              >
                {isEditingVariant ? t('Edit variant') : t('Add a variant')}
              </Typography>
              {isEditingVariant && (
                <Box
                  sx={{
                    mb: 1,
                    px: 1.25,
                    py: 0.75,
                    borderRadius: 1,
                    backgroundColor: 'rgba(124, 77, 255, 0.08)',
                    border: '1px solid rgba(124, 77, 255, 0.35)',
                    fontSize: 13
                  }}
                >
                  {t('Editing saved variant — make changes below, then click')}{' '}
                  <strong>{t('Update variant')}</strong>.
                </Box>
              )}
              <Grid sx={{ paddingBottom: 1 }}>
                <FormLabel>Gene</FormLabel>
              </Grid>

              {/* terminologyAvailability's own words, English until shown. */}
              {geneUnavailable && (
                <Alert severity="warning" sx={{ mb: 1 }}>
                  {t(geneUnavailable.message)}
                </Alert>
              )}

              {/* THE EDITOR'S GENE IS THE ONE SOURCE OF TRUTH. The input is the editor's gene,
                  and so is the selection: the option chosen, only while the gene is still its
                  name. Left uncontrolled, the selection outlived the gene: once Add (or Edit, or
                  "Add a variant in" a gene) changed the gene with focus elsewhere, MUI "reset"
                  the input to that stale option's label through onInputChange, putting the gene
                  back into the emptied editor, so Save sent the variant twice; and it rewrote the
                  gene of a variant opened for editing. A 'reset' is never the clinician's change,
                  so it is not taken either (TestForm.variantEditor.test.jsx). */}
              <Autocomplete
                clearOnBlur={false}
                options={geneOptions}
                noOptionsText={
                  geneUnavailable
                    ? t('Gene lookup unavailable — this is not a result')
                    : geneSearchTerm.length < 3
                    ? t('Type at least 3 characters')
                    : t('No matching genes')
                }
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option.name
                }
                value={
                  geneChoice && geneChoice.name === currentVariant.gene
                    ? geneChoice
                    : null
                }
                inputValue={currentVariant.gene}
                onInputChange={(_, value, reason) => {
                  if (reason === 'reset') return;
                  setGeneSearchTerm(value);
                  if (reason === 'input') variantGeneIdsRef.current = {};
                  setCurrentVariant((prev) => ({ ...prev, gene: value }));
                }}
                onChange={(_, value) => {
                  const chosen = value && typeof value === 'object';
                  const name = chosen ? value.name : value || '';
                  variantGeneIdsRef.current = chosen ? geneIdsOf(value.id) : {};
                  setGeneChoice(chosen ? value : null);
                  setGeneSearchTerm('');
                  setCurrentVariant((prev) => ({ ...prev, gene: name }));
                }}
                filterOptions={(options) => options}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    label={t('Search for Genes')}
                    placeholder={t('Search...')}
                  />
                )}
              />
            </Grid>

            <Grid size={12}>
              <FormLabel>Variant Details</FormLabel>
            </Grid>

            <Grid size={4}>
              <TextField
                variant="outlined"
                fullWidth
                label="g."
                value={currentVariant.variantG}
                onChange={(e) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    variantG: e.target.value
                  }))
                }
                sx={{
                  '& label.Mui-focused': { color: 'grey' }
                }}
              />
            </Grid>

            <Grid size={4}>
              <TextField
                variant="outlined"
                fullWidth
                label="c."
                value={currentVariant.variantC}
                onChange={(e) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    variantC: e.target.value
                  }))
                }
                sx={{
                  '& label.Mui-focused': { color: 'grey' }
                }}
              />
            </Grid>

            <Grid size={4}>
              <TextField
                variant="outlined"
                fullWidth
                label="p."
                value={currentVariant.variantP}
                onChange={(e) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    variantP: e.target.value
                  }))
                }
                sx={{
                  '& label.Mui-focused': { color: 'grey' }
                }}
              />
            </Grid>

            {/* A lab report's variant is described against a build and a versioned transcript,
                and cannot be saved without them (design rule 4); a variant entered by hand may
                give them, and need not. */}
            {(isReportVariant(currentVariant) ||
              currentVariant.transcript ||
              currentVariant.genomeBuild) && (
              <>
                <Grid size={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label={t('Transcript')}
                    value={currentVariant.transcript || ''}
                    error={
                      !!currentVariant.transcript &&
                      !isVersionedTranscript(currentVariant.transcript)
                    }
                    helperText={t(TRANSCRIPT_HELP)}
                    onChange={(e) =>
                      setCurrentVariant((prev) => ({
                        ...prev,
                        transcript: e.target.value.trim() || null
                      }))
                    }
                  />
                </Grid>
                <Grid size={6}>
                  <TextField
                    select
                    variant="outlined"
                    fullWidth
                    label={t('Genome build')}
                    value={currentVariant.genomeBuild || ''}
                    onChange={(e) =>
                      setCurrentVariant((prev) => ({
                        ...prev,
                        genomeBuild: e.target.value || null
                      }))
                    }
                    helperText={t(
                      'Never inferred: the build the report describes it against.'
                    )}
                  >
                    {GENOME_BUILDS.map((b) => (
                      <MenuItem key={b} value={b}>
                        {b}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </>
            )}

            <Grid size={6}>
              <Grid sx={{ paddingBottom: 1 }}>
                <FormLabel>Variant Interpretation</FormLabel>
              </Grid>
              <SelectInput
                fullWidth={true}
                variant="outlined"
                name="variantInterpretation"
                options={VARIANT_INTERPRETATION_OPTIONS}
                value={currentVariant.variantInterpretation}
                onChange={(e) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    variantInterpretation: e.target.value
                  }))
                }
              />
            </Grid>

            <Grid size={6}>
              <Grid sx={{ paddingBottom: 1 }}>
                <FormLabel>Variant Origin</FormLabel>
              </Grid>
              <SelectInput
                fullWidth={true}
                variant="outlined"
                name="origin"
                options={VARIANT_ORIGIN_OPTIONS}
                value={currentVariant.origin || 'unknown'}
                onChange={(e) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    origin: e.target.value
                  }))
                }
              />
            </Grid>

            <Grid size={6}>
              <Grid sx={{ paddingBottom: 1 }}>
                <FormLabel>Date Last Reviewed</FormLabel>
              </Grid>
              {/* The picker's value is a local instant; read by its local day (CLAUDE.md,
                  Dates), as the Test's own dates are. */}
              <DateInput
                value={asPickerDay(currentVariant.dateLastReviewed)}
                onChange={(val) =>
                  setCurrentVariant((prev) => ({
                    ...prev,
                    dateLastReviewed: val
                  }))
                }
                variant="outline"
              />
            </Grid>

            <Grid
              sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}
              size={12}
            >
              {isEditingVariant && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancelEditVariant}
                >
                  {t('Cancel')}
                </Button>
              )}
              <Button
                variant="contained"
                onClick={
                  isEditingVariant ? handleUpdateVariant : handleAddVariant
                }
              >
                {isEditingVariant
                  ? t('Update variant')
                  : t('Add another variant')}
              </Button>
            </Grid>
          </>
        )}

        {/* ── Notes and attachments ── */}
        <SectionHeading title={t('Notes and attachments')} />
        <Grid size={12} sx={unsavedSx('testNotes')} {...targetOf('testNotes')}>
          <Grid sx={{ paddingBottom: 1 }}>
            <FormLabel>Test Notes</FormLabel>
            {fieldMark('testNotes')}
          </Grid>
          <Box sx={{ width: '100%' }}>
            <TextField
              variant="outlined"
              fullWidth
              onChange={handleChange}
              name="testNotes"
              value={formValues.testNotes}
              disabled={fieldsLocked}
              multiline={true}
              slotProps={{
                input: {
                  endAdornment:
                    formValues.testNotes && !formReadOnly ? (
                      <InputAdornment
                        position="end"
                        sx={{ alignSelf: 'center' }}
                      >
                        <Tooltip title={t('Analyse for clinical terms')}>
                          <span style={{ lineHeight: 0 }}>
                            <IconButton
                              size="medium"
                              onClick={() =>
                                analyzeText(formValues.testNotes, 'manual')
                              }
                              disabled={analyzingNote}
                            >
                              <AutoAwesomeIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </InputAdornment>
                    ) : null
                }
              }}
            />
          </Box>
        </Grid>

        <ClinicalSuggestionsPanel
          state={clinicalSuggestions}
          onAccept={() =>
            acceptSuggestions().then((result) => {
              if (result?.success) {
                setSnack({
                  status: true,
                  msg: acceptedMessage(result, t),
                  severity: 'success'
                });
              } else {
                setSnack({
                  status: true,
                  msg: t('Failed to save suggestions'),
                  severity: 'error'
                });
              }
            })
          }
        />

        {!panelsAtTop && labReportPanels}

        <UploadFileList
          value={formValues.fileAttachments}
          familyId={familyMemberId}
          readOnly={formReadOnly}
          unsaved={unsaved.fields.has('fileAttachments')}
          onChange={(next) => {
            // Functional: uploads can finish faster than this form re-renders.
            setFormValues((prev) => ({ ...prev, fileAttachments: next }));
            setUnsavedChanges((prev) => ({ ...prev, edit: true }));
          }}
          onBusyChange={setUploadingFiles}
          onUploadComplete={(uploadData, name, file) => {
            attachmentChanges.trackUpload(name);
            const text = uploadData?.extractedText;
            if (text) handleAttachmentText(text, name);
            if (readsLabReports && file && isPdfFile(file, name)) {
              labReport.intake(file, {
                testNoteId: ensureTestId(),
                attachmentName: name,
                // Which person of a report about several this Test can take (TGCLOUD-1868, E4).
                testScope: {
                  pregnancyId: formValuesRef.current.pregnancyId,
                  fetusId: formValuesRef.current.fetusId
                }
              });
            }
          }}
        />

        <Grid
          container
          size={12}
          sx={{
            alignItems: 'center'
          }}
        >
          <Grid
            size={{
              xs: 6,
              sm: 7
            }}
          >
            <FormLabel component="label" className="form-label">
              Show in family
            </FormLabel>
            {fieldMark('showInFamily')}
          </Grid>
          <Grid
            container
            data-testid="show-in-family-control"
            size={{
              xs: 6,
              sm: 3
            }}
            sx={{
              alignItems: 'center',
              ...unsavedControl('showInFamily')
            }}
          >
            <Grid>
              <Switch
                color="secondary"
                checked={formValues.showInFamily ?? false}
                onChange={onToggleSwitch}
                disabled={fieldsLocked}
                name="showInFamily"
              />
            </Grid>
            <Grid>
              <Typography>
                {formValues.showInFamily ? t('Yes') : t('No')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: 'center'
            }}
          >
            <Grid
              size={{
                xs: 12,
                sm: 'auto'
              }}
            >
              <FormLabel>Reminder</FormLabel>
              {fieldMark('reminderEnabled')}
            </Grid>
            <Grid
              data-testid="reminder-control"
              sx={unsavedControl('reminderEnabled')}
            >
              <Switch
                checked={!!formValues.reminderEnabled}
                onChange={(e) => {
                  const enabled = e.target.checked;
                  setFormValues((prev) => {
                    const next = { ...prev, reminderEnabled: enabled };
                    if (enabled && !prev.reminderDate) {
                      next.reminderDate = computeDefaultReminderDate(
                        prev.dateRequested
                      );
                    }
                    return next;
                  });
                  setUnsavedChanges((prev) => ({ ...prev, edit: true }));
                }}
                name="reminderEnabled"
                disabled={fieldsLocked}
                color="secondary"
              />
            </Grid>
            {formValues.reminderEnabled && (
              <Grid
                sx={{ marginLeft: 14, ...unsavedSx('reminderDate') }}
                size={{
                  xs: 12,
                  sm: 6
                }}
              >
                <Grid sx={{ paddingBottom: 1 }}>
                  <FormLabel>Reminder Date</FormLabel>
                  {fieldMark('reminderDate')}
                </Grid>
                <DateInput
                  name="reminderDate"
                  value={formValues.reminderDate}
                  disablePast
                  minDate={asPickerDay(formValues.dateRequested) || new Date()}
                  onChange={(val) => {
                    setReminderTouched(true);
                    handleChange({
                      target: { name: 'reminderDate', value: val, type: 'date' }
                    });
                  }}
                  variant="outline"
                  helperText={t('Default is 2 weeks from Date Requested')}
                  disabled={fieldsLocked}
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        {!inReview && saveErrorAlert && <Grid size={12}>{saveErrorAlert}</Grid>}
        {!inReview && buttons}
      </Grid>
      {/* THE FOOTER (TGCLOUD-1868 D4): while a report is checked beside the Test, what was not
          read, how many parts are confirmed and why Save waits stay in view with Cancel and Save,
          at the foot of the Test pane however far it is scrolled. */}
      {inReview && (
        <VerificationFooter
          notRead={verification.notRead}
          waiting={choiceWaits}
          error={saveErrorAlert}
        >
          {buttons}
        </VerificationFooter>
      )}
    </form>
  );

  return (
    <VerificationContext.Provider value={verification}>
      <ReadingChecksContext.Provider value={checks}>
        <VerificationLayout view={verification} report={reportPane}>
          {testPane}
        </VerificationLayout>
      </ReadingChecksContext.Provider>
    </VerificationContext.Provider>
  );
}
